export default {
    computed:{
        recordsToSkipForNextPage(){
            return this.l_page * this.l_pageSize;
        },
        totalPages(){
            return ( this.l_totalRecords > 0 && this.l_pageSize > 0 ) ? Math.ceil( this.l_totalRecords / this.l_pageSize ) : 0;
        }
    },
    methods:{
        getTotalRecords(){
            return this.l_totalRecords;
        },
  
        setTotalRecords(totalRecords) {
            this.l_totalRecords = totalRecords;
        },
  
        async setOrderBy(orderBy, reload = false) {
            this.l_orderBy = orderBy;
            if (this.consoleLogs && reload) console.log("setOrderBy loadList");
            if (reload) await this.loadList(true);
        },
  
        getOrderBy(){
            return this.l_orderBy;
        },
  
        async setPageSize(size, reload = false) {
            this.l_pageSize = size;
            if (this.consoleLogs && reload) console.log("setPageSize loadList");
            if (reload) await this.loadList(true);
        },
  
        async setPage(page, reload = false){
            this.l_page = page;
            if (this.consoleLogs && reload) console.log("setPage loadList");
            if (reload) await this.loadList(true);
        },
  
        getPageSize(){
            return this.l_pageSize
        },
  
        getPage(){
            return this.l_page;
        },
  
        nextPage(reload = false) {
            let page = this.getPage();
            if ((page + 1) < this.totalPages) {
            this.setPage(page + 1, reload);
            }
        },
  
        previousPage(reload = false) {
            let page = this.getPage();
            if (page > 0){
            this.setPage(page - 1, reload);
            }
        },
  
        firstPage(reload = false) {
            this.setPage(0, reload);
        },
  
        lastPage(reload = false) {
            this.setPage(this.totalPages - 1, reload);
        }
    },
    data(){
        return {
            l_orderBy: this.defaultOrderBy,
            l_page: this.defaultPage,
            l_pageSize: this.defaultPageSize,
            l_totalRecords: 0,
        }
    }
}